import isEqual from 'lodash/isEqual';
import {useCallback, useEffect, useRef, useState} from 'react';
import ENDPOINT from '../constants/endpoints';
import useApi from './useApi';

export function useTaxonomy(taxonomy, params = {}, initialState = []) {
  const api = useApi();
  const [data, setData] = useState(initialState);
  const [isLoading, setIsLoading] = useState(true);
  const queryParams = useRef(params);

  const fetchTaxonomy = useCallback(async () => {
    setIsLoading(true);

    if (!ENDPOINT.TAXONOMIES[taxonomy]) {
      setIsLoading(false);
      return;
    }

    api.get(ENDPOINT.TAXONOMIES[taxonomy], queryParams.current, {
      handleError: () => {},
      handleSuccess: setData,
      handleComplete: () => {
        setIsLoading(false);
      },
    });
  }, [api, taxonomy]);

  useEffect(() => {
    void fetchTaxonomy();
  }, [fetchTaxonomy]);

  useEffect(() => {
    if (!isEqual(queryParams.current, params)) {
      queryParams.current = params;
      void fetchTaxonomy();
    }
  }, [fetchTaxonomy, params])

  return {data, isLoading};
}
